import { Product } from 'types';
import {
  DsoDiscounts,
  DsoBulkDiscountItemClient,
} from 'types/dso/DsoDiscounts.types';
import { isZeroCurrency } from 'utils';

export const getAvailableAddresses = (
  rows: { quantity: string; address: string }[],
  currentIndex: number,
  addressOptions: {
    label: string;
    value: string;
  }[]
) => {
  const selectedAddresses = rows
    .map((row, index) => (index !== currentIndex ? row.address : null))
    .filter(Boolean);

  return addressOptions.filter(
    option => !selectedAddresses.includes(option.value)
  );
};

export const getDisplayPriceAfterDiscount = (
  product: Product,
  discounts?: DsoDiscounts
): string | null => {
  const isFreeProduct = isZeroCurrency(product.displayPrice);
  if (!discounts || isFreeProduct) {
    return null;
  }

  const bulkDiscountProduct = discounts.bulkDiscountProducts.find(
    discountedProduct => discountedProduct.sku === product.sku
  );

  if (!bulkDiscountProduct) {
    return null;
  }

  const discountWithPrice = bulkDiscountProduct.discounts.find(
    d => d.displayPriceAfterDiscount
  );

  return discountWithPrice?.displayPriceAfterDiscount ?? null;
};

export const filterDsoBulkDiscountBySku = (
  product: Product,
  discounts?: DsoDiscounts
): DsoBulkDiscountItemClient[] | null => {
  const isFreeProduct = isZeroCurrency(product.displayPrice);
  if (!discounts || isFreeProduct) {
    return null;
  }

  const bulkDiscountProduct = discounts.bulkDiscountProducts.find(
    discountedProduct => discountedProduct.sku === product.sku
  );

  const skuDiscounts = bulkDiscountProduct?.discounts;
  if (skuDiscounts && skuDiscounts.length > 0) {
    return skuDiscounts;
  }

  const globalDiscounts = discounts.globalDiscounts;
  if (globalDiscounts && globalDiscounts.length > 0) {
    return globalDiscounts;
  }

  return null;
};
